import styled, { keyframes } from 'styled-components';
import { backgroundColors, easing, zIndex } from 'ui/theme';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

type Props = {
  isActive: boolean;
  overlayZIndex?: number;
};

export const Overlay = styled.div<Props>`
  animation-duration: ${({ isActive }) => (isActive ? '0.4s' : '0.3s')};
  animation-fill-mode: forwards;
  animation-name: ${({ isActive }) => (isActive ? fadeIn : fadeOut)};
  animation-timing-function: ${({ isActive }) => (isActive ? easing.entrance : easing.exit)};
  background: ${backgroundColors.backgroundScreen};
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: ${({ overlayZIndex }) => overlayZIndex ?? zIndex.dropdown - 1};
`;
